import { defaultAdultAge } from "@/helpers/defaultAdultAge.ts";
import { PersonType } from "@/helpers/types/types.ts";
import { EngineStoreData } from "@/stores/EngineStore/EngineStore.ts";
import { AdultType } from "@/stores/EngineStore/interfaces/AdultType.ts";
import { v4 as uuidv4 } from "uuid";

export const setAdultsHelper = (state: EngineStoreData, count: number, itemId: string) => {
  const existingAdults =
    state.cartAccommodationItems.find((CAI) => CAI.id === itemId)?.adults.slice(0, count) || [];

  // Preserve existing ages when updating the adults array
  const newAdults: AdultType[] = Array.from({ length: count - existingAdults.length }, () => ({
    id: uuidv4(),
    age: defaultAdultAge,
    type: PersonType.Adult,
  }));

  return {
    cartAccommodationItems: state.cartAccommodationItems?.map((CAI) => {
      if (CAI.id === itemId) {
        return { ...CAI, adults: [...existingAdults, ...newAdults] };
      }
      return CAI;
    }),
  };
};
